
import RcDomainObject from "@/domain/common/RcDomainObject.js";

import Result from "./Result.js";

export default class ResultsDomain extends RcDomainObject {
  
  constructor(domain, storage) {
    super(domain);
    this.storage = storage;
  }

  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Result(this.domain, item);
      }
    }
    return new Result(this.domain);
  }
}